import { FieldType } from "@certa/types";
import type { Field } from "../types";
import { nanoIdWithProcessId, getNanoId } from "../utils";

// Replaced from Date.now() to nano ids as in bulk duplication the ids will be same and will cause issues.
export const createField = ({
  processId,
  props
}: {
  processId: string;
  props?: Partial<Field>;
}) => {
  const newField: Field = {
    id: nanoIdWithProcessId(processId),
    tag: `field_${getNanoId()}`,
    body: "Untitled Field",
    fieldType: FieldType.CHAR,
    sourceCSVJSON: {},
    // Adding these here as well as these are the default values added by reverse parser
    // To have consistency during export and import
    isFilterable: true, // default value = true for Free Text if not hidden, Also see comment in field.model.ts if this can be undefined
    __createdAt: Date.now(),
    __modifiedAt: Date.now(),
    __tagReadonly: false,
    ...props
  };
  return newField;
};
